export interface Acknowledgement {
  name: string;
  license: string;
  publisher: string;
  repository: string;
  packages?: readonly string[];
  copyright?: string;
}

export interface DirectDependencyExclusion {
  name: string;
  reason: string;
}

export const acknowledgements: Acknowledgement[] = [
  {
    name: 'Ant Design Icons',
    license: 'MIT',
    publisher: 'Ant Design Team',
    repository: 'https://github.com/ant-design/ant-design-icons',
    packages: ['@ant-design/icons'],
  },
  {
    name: 'Base UI',
    license: 'MIT',
    publisher: 'MUI Team',
    repository: 'https://github.com/mui/base-ui',
    packages: ['@base-ui/react'],
  },
  {
    name: 'Ruff',
    license: 'MIT',
    publisher: 'Astral Software Inc.',
    repository: 'https://github.com/astral-sh/ruff',
    packages: ['@astral-sh/ruff-wasm-web'],
  },
  {
    name: 'base64-js',
    license: 'MIT',
    publisher: 'T. Jameson Little',
    repository: 'https://github.com/beatgammit/base64-js',
    packages: ['base64-js'],
  },
  {
    name: 'CodeMirror',
    license: 'MIT',
    publisher: 'Marijn Haverbeke',
    repository: 'https://github.com/codemirror',
    packages: [
      '@codemirror/autocomplete',
      '@codemirror/commands',
      '@codemirror/lang-python',
      '@codemirror/language',
      '@codemirror/state',
      '@codemirror/view',
      'crelt',
    ],
  },
  {
    name: 'dnd kit',
    license: 'MIT',
    publisher: 'Clauderic Demers',
    repository: 'https://github.com/clauderic/dnd-kit',
    packages: ['@dnd-kit/core', '@dnd-kit/modifiers'],
  },
  {
    name: 'D3',
    license: 'ISC',
    publisher: 'Mike Bostock',
    repository: 'https://github.com/d3',
    packages: ['d3-drag', 'd3-selection'],
  },
  {
    name: 'Dexie',
    license: 'Apache-2.0',
    publisher: 'David Fahlander',
    repository: 'https://github.com/dexie/Dexie.js',
    packages: ['dexie', 'dexie-react-hooks'],
  },
  {
    name: 'DOMPurify',
    license: 'MPL-2.0 OR Apache-2.0',
    publisher: 'Cure53',
    repository: 'https://github.com/cure53/DOMPurify',
    packages: ['dompurify'],
  },
  {
    name: 'EJS',
    license: 'Apache-2.0',
    publisher: 'Matthew Eernisse',
    repository: 'https://github.com/mde/ejs',
    packages: ['ejs'],
  },
  {
    name: 'Emotion',
    license: 'MIT',
    publisher: 'Emotion Contributors',
    repository: 'https://github.com/emotion-js/emotion',
    packages: ['@emotion/react', '@emotion/styled'],
  },
  {
    name: 'FileSaver.js',
    license: 'MIT',
    publisher: 'Eli Grey',
    repository: 'https://github.com/eligrey/FileSaver.js',
    packages: ['file-saver'],
  },
  {
    name: 'Gridstack.js',
    license: 'MIT',
    publisher: 'Alain Dumesny',
    repository: 'https://github.com/gridstack/gridstack.js',
    packages: ['gridstack'],
  },
  {
    name: 'i18next',
    license: 'MIT',
    publisher: 'Jan Muhlemann and contributors',
    repository: 'https://github.com/i18next/i18next',
    packages: ['i18next', 'i18next-browser-languagedetector', 'i18next-http-backend', 'i18next-locize-backend', 'react-i18next'],
  },
  {
    name: 'JavaScript State Machine',
    license: 'MIT',
    publisher: 'Jake Gordon',
    repository: 'https://github.com/jakesgordon/javascript-state-machine',
    packages: ['javascript-state-machine'],
  },
  {
    name: 'JSZip',
    license: 'MIT OR GPL-3.0-or-later',
    publisher: 'Stuart Knightley',
    repository: 'https://github.com/Stuk/jszip',
    packages: ['jszip'],
  },
  {
    name: 'Lodash',
    license: 'MIT',
    publisher: 'John-David Dalton',
    repository: 'https://github.com/lodash/lodash',
    packages: ['lodash', 'lodash.debounce', 'lodash.sortby'],
  },
  {
    name: 'Lottie React',
    license: 'MIT',
    publisher: 'David Gamote',
    repository: 'https://github.com/Gamote/lottie-react',
    packages: ['lottie-react'],
  },
  {
    name: 'Luxon',
    license: 'MIT',
    publisher: 'Isaac Cambron',
    repository: 'https://github.com/moment/luxon',
    packages: ['luxon'],
  },
  {
    name: 'LZMA-JS',
    license: 'MIT',
    publisher: 'Nathan Rugg',
    repository: 'https://github.com/nmrugg/LZMA-JS',
    packages: ['lzma'],
  },
  {
    name: 'Marked',
    license: 'MIT',
    publisher: 'Christopher Jeffrey and contributors',
    repository: 'https://github.com/markedjs/marked',
    packages: ['marked'],
  },
  {
    name: 'Material UI',
    license: 'MIT',
    publisher: 'MUI Team',
    repository: 'https://github.com/mui/material-ui',
    packages: ['@mui/icons-material', '@mui/material'],
  },
  {
    name: 'micro:bit File System',
    license: 'MIT',
    publisher: 'Micro:bit Educational Foundation',
    repository: 'https://github.com/microbit-foundation/microbit-fs',
    packages: ['@microbit/microbit-fs'],
  },
  {
    name: 'Monaco Editor',
    license: 'MIT',
    publisher: 'Microsoft Corporation and Suren Atoyan',
    repository: 'https://github.com/microsoft/monaco-editor',
    packages: ['@monaco-editor/loader', '@monaco-editor/react', 'monaco-editor'],
  },
  {
    name: 'MUI X Charts',
    license: 'MIT',
    publisher: 'MUI Team',
    repository: 'https://github.com/mui/mui-x',
    packages: ['@mui/x-charts'],
  },
  {
    name: 'Pyright',
    license: 'MIT',
    publisher: 'Microsoft Corporation',
    repository: 'https://github.com/microsoft/pyright',
  },
  {
    name: 'Ramda',
    license: 'MIT',
    publisher: 'Scott Sauyet',
    repository: 'https://github.com/ramda/ramda',
    packages: ['ramda'],
  },
  {
    name: 'React',
    license: 'MIT',
    publisher: 'Meta Open Source',
    repository: 'https://github.com/facebook/react',
    packages: ['react', 'react-dom'],
  },
  {
    name: 'react-fast-compare',
    license: 'MIT',
    publisher: 'Chris Bolin',
    repository: 'https://github.com/FormidableLabs/react-fast-compare',
    packages: ['react-fast-compare'],
  },
  {
    name: 'React GA4',
    license: 'MIT',
    publisher: 'Han Lin Yap',
    repository: 'https://github.com/codler/react-ga4',
    packages: ['react-ga4'],
  },
  {
    name: 'React Icons',
    license: 'MIT',
    publisher: 'Goran Gajic',
    repository: 'https://github.com/react-icons/react-icons',
    packages: ['react-icons'],
  },
  {
    name: 'React Intl',
    license: 'BSD-3-Clause',
    publisher: 'Eric Ferraiuolo and FormatJS contributors',
    repository: 'https://github.com/formatjs/formatjs',
    packages: ['react-intl'],
  },
  {
    name: 'React Markdown',
    license: 'MIT',
    publisher: 'unified collective contributors',
    repository: 'https://github.com/remarkjs/react-markdown',
    packages: ['react-markdown', 'rehype-sanitize', 'remark-gfm'],
  },
  {
    name: 'React PDF',
    license: 'MIT',
    publisher: 'Diego Muracciole',
    repository: 'https://github.com/diegomura/react-pdf',
    packages: ['@react-pdf/renderer'],
  },
  {
    name: 'React Router',
    license: 'MIT',
    publisher: 'Remix Software',
    repository: 'https://github.com/remix-run/react-router',
    packages: ['react-router-dom'],
  },
  {
    name: 'Redux',
    license: 'MIT',
    publisher: 'Redux contributors',
    repository: 'https://github.com/reduxjs/redux-toolkit',
    packages: ['@piotr-cz/redux-persist-idb-storage', '@reduxjs/toolkit', 'react-redux', 'redux', 'redux-persist', 'redux-watch'],
  },
  {
    name: 'remote-web-worker',
    license: 'MIT',
    publisher: 'Jan Nicklas',
    repository: 'https://github.com/jantimon/remote-web-worker',
    packages: ['remote-web-worker'],
  },
  {
    name: 'TanStack Query',
    license: 'MIT',
    publisher: 'Tanner Linsley and TanStack contributors',
    repository: 'https://github.com/TanStack/query',
    packages: ['@tanstack/react-query'],
  },
  {
    name: 'tinygradient',
    license: 'MIT',
    publisher: 'Damien "Mistic" Sorel',
    repository: 'https://github.com/mistic100/tinygradient',
    packages: ['tinygradient'],
  },
  {
    name: 'Toolpad',
    license: 'MIT',
    publisher: 'Toolpad Team',
    repository: 'https://github.com/mui/toolpad',
    packages: ['@toolpad/core'],
  },
  {
    name: 'VS Code Language Server Protocol',
    license: 'MIT',
    publisher: 'Microsoft Corporation',
    repository: 'https://github.com/microsoft/vscode-languageserver-node',
    packages: ['vscode-jsonrpc', 'vscode-languageserver-protocol'],
  },
  {
    name: 'WPILib',
    license: 'BSD-3-Clause',
    publisher: 'FIRST and WPILib contributors',
    repository: 'https://github.com/wpilibsuite/allwpilib',
    copyright: 'Copyright (c) 2009-2026 FIRST and other WPILib contributors All rights reserved.',
  },
];

export const excludedDirectDependencyPackages: DirectDependencyExclusion[] = [
  {
    name: '@types/dompurify',
    reason: 'Type-only package; excluded as development metadata rather than runtime user-facing code.',
  },
  {
    name: '@types/ejs',
    reason: 'Type-only package; excluded as development metadata rather than runtime user-facing code.',
  },
  {
    name: '@types/file-saver',
    reason: 'Type-only package; excluded as development metadata rather than runtime user-facing code.',
  },
  {
    name: '@types/lodash.debounce',
    reason: 'Type-only package; excluded as development metadata rather than runtime user-facing code.',
  },
  {
    name: '@types/marked',
    reason: 'Type-only package; excluded as development metadata rather than runtime user-facing code.',
  },
  {
    name: '@types/ramda',
    reason: 'Type-only package; excluded as development metadata rather than runtime user-facing code.',
  },
  {
    name: 'sphero-sdk',
    reason: 'Explicitly excluded from this acknowledgement pass by Micah/user scope guidance.',
  },
];
